export const SEC_FORMAT = /^\d+$/
export const MIN_SEC_FORMAT = /^\d+:\d+$/
export const MIN_SEC_FRACTION_FORMAT = /^\d+(\.|,)\d{1}$/
export const HR_MIN_SEC_FORMAT = /^\d+:\d+:\d+$/

export const HOUR_SECONDS = 3600

export const IMPERSONATION_IDLE_TIMEOUT_MS = 60 * 60 * 1000
